import { useState } from "react";
import {
  User,
  KeyRound,
  LogOut,
  Stethoscope,
  Syringe,
  Brain,
  Salad,
  Pill,
  Briefcase,
} from "lucide-react";
import type { ElementType } from "react";
import { theme } from "../../styles/theme";
import logo from "../../../assets/LOGO SEM FUNDO.PNG";
import { Usuario } from "../../../types";
import ModalTrocarSenha from "../ModalTrocarSenha";

interface HeaderProps {
  usuario: Usuario | null;
  onLogout: () => void;
  onTrocarSenha: (senhaAtual: string, novaSenha: string) => Promise<void>;
}

export default function Header({
  usuario,
  onLogout,
  onTrocarSenha,
}: HeaderProps) {
  const [mostrarMenu, setMostrarMenu] = useState(false);
  const [mostrarModalSenha, setMostrarModalSenha] = useState(false);

  // Ícone por categoria profissional (espelho do UsuarioCard). Usuário sem
  // categoria definida é tratado como médico (mesmo padrão do AuthContext, B89).
  const categoriaIcons: Record<string, ElementType> = {
    medico: Stethoscope,
    enfermeiro: Syringe,
    psicologo: Brain,
    nutricionista: Salad,
    farmaceutico: Pill,
    administrativo: Briefcase,
  };
  const IconeCategoria =
    categoriaIcons[usuario?.categoria || "medico"] || Stethoscope;

  return (
    <>
      <header
        style={{
          background: theme.gradients.header,
          boxShadow: theme.shadows.lg,
        }}
      >
        <div
          style={{
            maxWidth: "1280px",
            margin: "0 auto",
            padding: "20px 24px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              {/* SEU LOGO */}
              <img
                src={logo}
                alt="Logo"
                style={{
                  width: "60px",
                  height: "60px",
                  objectFit: "contain",
                  borderRadius: "50%",
                  background: "white",
                  padding: "4px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                }}
              />
              <div>
                <h1
                  style={{
                    fontSize: "28px",
                    fontWeight: "bold",
                    color: "white",
                    margin: 0,
                    fontFamily: theme.fonts.sans,
                  }}
                >
                  HEPATO TX RONDÔNIA
                </h1>
                <p
                  style={{
                    fontSize: "14px",
                    color: "rgba(255,255,255,0.9)",
                    margin: 0,
                    fontWeight: "500",
                    fontFamily: theme.fonts.sans,
                  }}
                >
                  Sistema LGPD + IA
                </p>
              </div>
            </div>
          </div>

          {usuario && (
            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <div
                style={{
                  textAlign: "right",
                  background: "rgba(255,255,255,0.15)",
                  padding: "12px 20px",
                  borderRadius: theme.borderRadius.lg,
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255,255,255,0.2)",
                }}
              >
                <p
                  style={{
                    fontSize: "15px",
                    fontWeight: "600",
                    color: "white",
                    margin: 0,
                    fontFamily: theme.fonts.sans,
                  }}
                >
                  <IconeCategoria size={14} style={{ marginRight: "6px" }} />{" "}
                  {usuario.email || usuario.usuario || "Usuário"}
                </p>
                <p
                  style={{
                    fontSize: "13px",
                    color: "rgba(255,255,255,0.9)",
                    margin: 0,
                    fontFamily: theme.fonts.sans,
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  {usuario.nome}
                </p>
              </div>

              {/* MENU DROPDOWN */}
              <div style={{ position: "relative" }}>
                <button
                  onClick={() => setMostrarMenu(!mostrarMenu)}
                  style={{
                    padding: "12px 20px",
                    background: "rgba(255,255,255,0.2)",
                    backdropFilter: "blur(10px)",
                    color: "white",
                    border: "2px solid rgba(255,255,255,0.3)",
                    borderRadius: theme.borderRadius.lg,
                    fontSize: "14px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    transition: theme.transitions.normal,
                    fontFamily: theme.fonts.sans,
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.background = "rgba(255,255,255,0.3)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.background = "rgba(255,255,255,0.2)";
                  }}
                >
                  <User size={14} style={{ marginRight: "4px" }} /> Menu
                  <span style={{ fontSize: "10px" }}>
                    {mostrarMenu ? "▲" : "▼"}
                  </span>
                </button>

                {/* DROPDOWN */}
                {mostrarMenu && (
                  <div
                    style={{
                      position: "absolute",
                      top: "calc(100% + 8px)",
                      right: 0,
                      background: "white",
                      borderRadius: theme.borderRadius.lg,
                      boxShadow: theme.shadows.xl,
                      minWidth: "200px",
                      overflow: "hidden",
                      zIndex: 1000,
                      border: `2px solid ${theme.primary[200]}`,
                    }}
                  >
                    <button
                      onClick={() => {
                        setMostrarMenu(false);
                        setMostrarModalSenha(true);
                      }}
                      style={{
                        width: "100%",
                        padding: "12px 16px",
                        background: "white",
                        border: "none",
                        borderBottom: `1px solid ${theme.gray[200]}`,
                        textAlign: "left",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontFamily: theme.fonts.sans,
                        color: theme.gray[700],
                        transition: "background 0.2s",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.background = theme.primary[50];
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.background = "white";
                      }}
                    >
                      <KeyRound size={14} /> Trocar Senha
                    </button>

                    <button
                      onClick={() => {
                        setMostrarMenu(false);
                        onLogout();
                      }}
                      style={{
                        width: "100%",
                        padding: "12px 16px",
                        background: "white",
                        border: "none",
                        textAlign: "left",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontFamily: theme.fonts.sans,
                        color: "#dc2626",
                        transition: "background 0.2s",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.background = "#fee";
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.background = "white";
                      }}
                    >
                      <LogOut size={14} /> Sair
                    </button>
                  </div>
                )}
              </div>

              {/* FECHAR MENU AO CLICAR FORA */}
              {mostrarMenu && (
                <div
                  onClick={() => setMostrarMenu(false)}
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 999,
                  }}
                />
              )}
            </div>
          )}
        </div>
      </header>

      {/* MODAL TROCAR SENHA */}
      {mostrarModalSenha && (
        <ModalTrocarSenha
          onTrocarSenha={onTrocarSenha}
          onClose={() => setMostrarModalSenha(false)}
        />
      )}
    </>
  );
}
